import {Button, Card, Result, Spin} from "antd";
import ApiService from "../Service/ApiService";
import {useHistory} from "react-router-dom";
import {useEffect, useState} from "react";

export default function RegisterVerification() {
    const params = new URLSearchParams(window.location.search);
    const key = params.get('key');
    const history = useHistory();

    const [verified, setVerified] = useState(1)

    // const verify = async () => {
    //     if(key) {
    //         const res = await ApiService.Auth.Verification(key)
    //         if(res.success) {
    //             setVerified(1)
    //         }
    //     }
    // }

    const redirectLogin = () => {
        history.push('/app/login')
    }

    // useEffect(() => {
    //     verify();
    // }, [])

    return (
        <>
            <div style={{display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center', height: '100%', backgroundColor: '#edf2f8'}}>
                <Card title={verified === 0 ? 'Verifying...' : 'Success'} style={{minWidth: 400}}>
                    {
                        verified === 1 && (
                            <Result
                                status="success"
                                title="Your account was created successfully."
                                subTitle="You can continue using the application!"
                                extra={[
                                    <Button type="primary" key="console" onClick={redirectLogin}>
                                        Login
                                    </Button>
                                ]}
                            />
                        )
                    }
                    {
                        verified === 0 && (
                            <Result
                                status="info"
                                title={(<div>Your email is verifying...</div>)}
                                subTitle={''}
                                extra={[
                                    <Spin />
                                ]}
                            />
                        )
                    }
                </Card>
            </div>
        </>
    )
}